/*
import {
  hf,
  ht,
  cr,
  gs,
  ls,
} from 'lib';
*/
import * as cr from './_cr';
import * as gs from "./_csGbl";
import * as ls from "./_csLcl"; // local state

import * as icm from './icm';

import * as icvBaseS10Rz from './icvBaseS10Rz';

import * as icv_42S10To from './icv_42S10To';
import * as icv_42S10Co from './icv_42S10Co';

export const N = (pDz: {
}) => {

  const _gUserz = gs.useUserz();

  const _sPz = ls.usePagez({
    steps: [0],
    phs: 'dpy',
    lblz: icm.grtLblz({
    tgt: 'スタッフ権限割当',
    })
  });
 
  icm.loadAtTopAsync({
    _31r_fst: _gUserz.crt._31rz?._fst,
    frcUdt: _sPz.udt,
  });

  return (
    cr.c(icvBaseS10Rz.N, {
      key: -10,
      cz: {
        pageName: 
          _sPz.crt.steps[0] == 0 ?
            _sPz.crt.lblz.ttlz.top
          : _sPz.crt.steps[0] == 1 ?
            _sPz.crt.lblz.ttlz.ctt
          : ''
      },
      oClds: [

        _sPz.crt.steps[0] == 0 ?
        cr.c(icv_42S10To.N, {
          key: -10,
          sPz: _sPz,
        })
        : null,

        _sPz.crt.steps[0] == 1 ?
        cr.c(icv_42S10Co.N, {
          key: -20,
          sPz: _sPz,
        })
        : null,

      ]
    })
  );
};
